import { createSlice } from '@reduxjs/toolkit'

const iscrizioniSlice = createSlice({
  name: 'iscrizioni',
  initialState: {},
  reducers: {
    setGrouping(state, action) {
      state.grouping = action.payload
    },
    setIscrizione(state, action) {
      state.iscrizione = action.payload
    },
    setIscrizioneField(state, action) {
      if (!state.iscrizione) state.iscrizione = {}
      state.iscrizione[action.payload.field] = action.payload.value
    },
  },
})

export const { setGrouping, setIscrizione, setIscrizioneField } =
  iscrizioniSlice.actions

export default iscrizioniSlice.reducer
